import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IContactCodeLog } from 'legacy/lut/classes/models/IFormCodeLog'
import * as React from 'react'
import { useMemo } from 'react'

import { Table } from 'core-components/library/list'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export interface IProps {
  contactId: string
  onClose: () => void
  type: string
}

export const ContactCodeLogs = (props: IProps) => {
  const getColumn = useMemo(() => {
    return [
      { field: 'EntryId', title: 'EntryId', priority: 1 },
      { field: 'ContactId', title: 'ContactId', priority: 2 },
      { field: 'ProfilingTeamStatus', title: 'Staus', priority: 3 },
      { field: 'Code', title: 'Code', priority: 4 },
      { field: 'Action', title: 'Action', priority: 5 },
      { field: 'ActionFrom', title: 'ActionFrom', priority: 6 },
      { field: 'Comment', title: 'Comment', priority: 7 },
      { field: 'CreatedDate', title: 'CreatedDate', priority: 8 },
      { field: 'CreatedFrom', title: 'CreatedBy', priority: 9 },
    ]
  }, [])
  const crudSource = useMemo(() => {
    const source = CrudStore.get(CrudStoreItem.ContactCodeLog, 'ContactLog')
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'ContactId',
          operator: Operator.EQUAL,
          value: props.contactId,
        },
        {
          field: 'Type',
          operator: Operator.EQUAL,
          value: props.type,
        },
      ],
    }
    source.setFilter(filter)
    source.setSort({ field: 'EntryId', dir: 'desc' })
    return source
  }, [props.contactId])

  return (
    <Table<IContactCodeLog>
      key={props.contactId}
      header
      pagination
      source={crudSource}
      columns={getColumn}
    />
  )
}
